export default __webpack_public_path__ + "static/media/1_0084.1c4973db.webp";